import { render, staticRenderFns } from "./FlightItem.vue?vue&type=template&id=47168b1c&scoped=true&"
import script from "./FlightItem.vue?vue&type=script&lang=js&"
export * from "./FlightItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightItem.vue?vue&type=style&index=0&id=47168b1c&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47168b1c",
  null
  
)

export default component.exports